import React from 'react';

// Context
export const LayoutContext = React.createContext({
	layout: {},
	deviceType: null,
	deviceOrientation: null,
	isMobile: false,
	isDesktop: false,
	isPhoneLayout: false,
	isTabletLayout: false,
	isDesktopLayout: false,
	screenLayout: null,
	browserName: null,

	// Getters
	getLayout: () => {},
	getRegionHeight: () => {},
	getRegionWidth: () => {},

	// utils
	collapseSidePanel: () => {},
	setHidden: () => {},
	resize: () => {},

	// components can subscribe/un-subscribe to 'layoutUpdate' event
	subscribeLayoutUpdateEvent: () => {},
	unsubscribeLayoutUpdateEvent: () => {},
});
